
import React from 'react';
import { Editor } from '@tiptap/react';
import { List, ListOrdered } from 'lucide-react';
import EditorButton from '../buttons/EditorButton';
import EditorButtonGroup from '../buttons/EditorButtonGroup';

interface ListButtonsProps {
  editor: Editor;
}

const ListButtons = ({ editor }: ListButtonsProps) => {
  return (
    <EditorButtonGroup>
      <EditorButton 
        onClick={() => editor.chain().focus().toggleBulletList().run()}
        isActive={editor.isActive('bulletList')}
        title="Liste à puces"
        icon={<List className="h-4 w-4" />}
      />
      <EditorButton 
        onClick={() => editor.chain().focus().toggleOrderedList().run()}
        isActive={editor.isActive('orderedList')}
        title="Liste numérotée"
        icon={<ListOrdered className="h-4 w-4" />}
      />
    </EditorButtonGroup>
  );
};

export default ListButtons;
